import React from 'react'
import { TMDB_IMG_URL } from '../utils/constant';
import { Link } from 'react-router-dom'

const MovieList = ({ title, movies, searchMovie = false }) => {
    return (
        <div className='px-8'>
            <h1 className={`${searchMovie ? "text-black" : "text-white"} text-3xl py-7 `}>{title}</h1>
            <div className='flex overflow-x-auto no-scrollbar cursor-pointer  '>
                <div className='flex items-center'>
                {
                            movies?.map((movie) => (
                                <div key={movie.id} className="movie-card w-48 pr-2">
                                    <Link to={`/single/${movie.id}`} className="block">
                                        <img
                                            src={`${TMDB_IMG_URL}${movie.poster_path}`}
                                            alt={movie.title}
                                            className="w-52"
                                        />
                                        <h6 className='text-center text-sm pt-2 text-white'>{movie.title}</h6>
                                        <p className='text-center pt-1 pb-4 text-white'>Rating: {movie.vote_average ? movie.vote_average.toFixed(1) : 'N/A'}</p>
                                    </Link>
                                </div>
                            ))
                        }
                </div>
            </div>
        </div>
    )
}

export default MovieList



